/** Curated public Soccer Analytics Blog posts — static metadata only (WD-07). No Notion token or runtime fetch. */

export const BLOG_NOTION_INDEX_URL = 'https://datarook.notion.site/27ed64111f0380438713c08fa11dd860';

export const NEW_TAB_NOTE =
  "Opens in a new tab. Use that tab's back button or return to this DataRook page.";

export const blogArticles = [
  {
    id: 'norway',
    title: "We've Never Beaten Norway. The Data Says That Ends Tonight.",
    excerpt:
      'Published live at halftime of Brazil vs Norway and completed with the post-game autopsy: the penalty-stripped xG ledger, a farewell to Neymar, and the scenes from a Norwegian living room.',
    date: 'July 2026',
    link: 'https://datarook.notion.site/394d64111f038092a66eea10c8fbb43a',
    featured: true,
  },
  {
    id: 'yamal',
    title: 'Generational Talent in Person… Finally!',
    excerpt:
      "A Twelve Football–powered read on why Spain's right half-space points at Saudi Arabia's soft left, plus the live verdict from inside the stadium.",
    date: 'June 2026',
    link: 'https://datarook.notion.site/385d64111f03809cabc2d0de17e38e95',
  },
  {
    id: 'first-world-cup-game',
    title: 'My First Ever World Cup Game',
    excerpt:
      'A soccer guy and a data guy adopt South Africa for a day and road-trip to Atlanta. A golden-zone read on Czechia vs. Bafana Bafana, then the live verdict from Mercedes-Benz Stadium.',
    date: 'June 2026',
    link: 'https://datarook.notion.site/383d64111f03808ea1e9d86d5ef8dfa6',
  },
  {
    id: 'neymar',
    title: 'I Believe in Neymar. Does the Data?',
    excerpt:
      "A soccer guy and a data guy argue over one question: can Neymar still help Brazil? Fan heart vs. Twelve Football data.",
    date: 'June 2026',
    link: 'https://datarook.notion.site/37dd64111f038074b969cead5fc0bd51',
  },
  {
    id: 'group-d',
    title: "Chasing the Cup: A Family Scouting Guide to Team USA's Group D",
    excerpt:
      "A family-friendly scouting guide that turns Team USA's Group D opponents — Paraguay, Australia, and Türkiye — into simple watch-points to count, compare, and debate at halftime.",
    date: 'June 2026',
    link: 'https://datarook.notion.site/36cd64111f038037ba6ec8cf28978214',
  },
  {
    id: 'one-knox-title-fight',
    title: "First Place Showdown: What the Data Says About Tonight's Title Fight",
    excerpt:
      "Deep dive into Knoxville's professional club competing in USL League One — match data and Twelve Football analysis ahead of a title fight.",
    date: 'October 2025',
    link: 'https://datarook.notion.site/27fd64111f038047be4dfbcad39c40cc',
  },
  {
    id: 'tale-of-two-matches',
    title: 'When the Data Meets Reality: A Tale of Two Matches',
    excerpt:
      'Playoff coverage for One Knoxville SC: where the numbers lined up with the night, and where they did not.',
    date: 'October 2025',
    link: 'https://datarook.notion.site/284d64111f0380369b9fdf244a97d218',
  },
  {
    id: 'biggest-game',
    title: 'Predicting the Biggest Game in Knoxville Soccer History',
    excerpt:
      'A Twelve Football–powered look at One Knoxville SC vs Spokane in the 2025 USL League One Championship, written on match day.',
    date: 'November 2025',
    link: 'https://datarook.notion.site/2add64111f038066a529fbd3bbbca537',
  },
];

export const featuredBlogArticles = blogArticles.filter((article) => article.featured);
export const otherBlogArticles = blogArticles.filter((article) => !article.featured);
